/**
 * Support Us banner dismiss behaviour.
 *
 * Uses a cookie so the banner stays hidden for N days
 * across sessions, then reappears automatically.
 */

const COOKIE_NAME = 'rh_support_banner_dismissed';
const DISMISS_DAYS = 3;

function setDismissCookie(days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=1; expires=${date.toUTCString()}; path=/; SameSite=Lax${secure}`;
}

function hasDismissCookie() {
  return document.cookie.split('; ').some((c) => c.startsWith(`${COOKIE_NAME}=`));
}

export default function initSupportBanner() {
  const banner = document.querySelector('.js-support-banner');
  if (!banner) return;

  if (hasDismissCookie()) {
    banner.classList.add('is-hidden');
    banner.setAttribute('aria-hidden', 'true');
    return;
  }

  const closeBtn = banner.querySelector('.js-support-banner-close');
  if (!closeBtn) return;

  closeBtn.addEventListener('click', () => {
    banner.classList.add('is-hidden');
    banner.setAttribute('aria-hidden', 'true');
    setDismissCookie(DISMISS_DAYS);
  });
}
